import { render } from "./Loader.vue?vue&type=template&id=9594b368"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
script.render = render

export default script